import React, { useEffect, useState, useRef } from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
function CountUp({
  target,
  duration = 1.8
}: {
  target: number;
  duration?: number;
}) {
  const [count, setCount] = useState(0);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const startTime = performance.now();
    const step = (now: number) => {
      const progress = Math.min((now - startTime) / (duration * 1000), 1);
      // Ease out
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);else setCount(target);
    };
    requestAnimationFrame(step);
  }, [target, duration]);
  return <>{count.toLocaleString('es-AR')}</>;
}
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-72">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-73">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.08)_0%,rgba(0,0,0,0)_70%)]" data-id="element-74" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#C9A84C]/5 rounded-full blur-3xl" data-id="element-75" />
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6 flex flex-col items-center" data-id="element-77">
          <span className="text-[#C9A84C] tracking-[0.2em] text-sm md:text-base font-bold uppercase mb-2" data-id="element-78">
            Mentoría de Mentalidad
          </span>
          <div className="w-12 h-[1px] bg-[#C9A84C]" data-id="element-79" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-9xl font-bold text-white leading-[0.95] mb-8 font-['Bebas_Neue']" data-id="element-80">
          TU PROBLEMA NO ES FALTA DE OPORTUNIDADES.
          <br data-id="element-81" />
          <span className="text-[#C9A84C]" data-id="element-82">ES FALTA DE DISCIPLINA.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 font-light" data-id="element-83">
          Mentoría intensiva en vivo para personas que dejaron de tolerar su
          propia mediocridad.
        </motion.p>

        <div className="max-w-xl mx-auto mb-8 px-4 py-3 border border-[#C9A84C]/40 rounded-lg bg-[#C9A84C]/8 text-center text-sm text-gray-200 tracking-wide" data-id="element-84">
          Para personas que arrancan fuerte, se sabotean y ya no confían en su
          palabra.
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.55
      }} className="flex items-center justify-center gap-6 mb-10" data-id="element-85">
          {/* Avatars stack */}
          <div className="flex -space-x-2" data-id="element-86">
            {['#4B5563', '#6B7280', '#374151', '#1F2937', '#9CA3AF'].map((color, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-[#0a0a0a] flex items-center justify-center text-white text-[10px] font-bold" style={{
            background: color
          }} data-id="element-87">
                  {['M', 'F', 'V', 'T', 'R'][i]}
                </div>)}
          </div>
          <div className="text-left" data-id="element-88">
            <p className="text-white font-bold text-lg leading-none" data-id="element-89">
              +<CountUp target={247} data-id="element-90" />
            </p>
            <p className="text-gray-500 text-xs uppercase tracking-wide mt-0.5" data-id="element-91">
              personas ya transformaron su mentalidad
            </p>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col items-center gap-4" data-id="element-92">
          <Button size="lg" className="w-full md:w-auto text-lg" onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-93">
            QUIERO RESERVAR MI LUGAR
          </Button>
          <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-94">
            Acceso al grupo privado de WhatsApp donde se comparten los links de
            Zoom
          </p>
          <a href="https://wa.me/5491166604113?text=Hola%2C%20tengo%20una%20duda%20sobre%20la%20mentor%C3%ADa%20por%20Zoom." target="_blank" rel="noreferrer" className="inline-block mt-1 px-5 py-2.5 rounded-full bg-[#25D366] text-black font-bold text-sm no-underline" data-id="element-95">
            🟢 Tengo dudas, hablar por WhatsApp
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-96">
        <div className="w-[1px] h-16 bg-gradient-to-b from-[#C9A84C] to-transparent" data-id="element-97" />
      </motion.div>
    </section>;
}